/**
 * 스크롤 컨테이너의 "더 있다" 판정 — 순수 함수 (useScrollHint 가 쓴다).
 *   none: 넘치지 않음 · more: 아래에 더 있음 · end: 끝까지 내렸음
 * 1~2px 오차는 서브픽셀 스크롤·iOS 바운스 때문에 허용한다.
 */
export type ScrollHint = "none" | "more" | "end";

export function scrollHint(scrollTop: number, clientHeight: number, scrollHeight: number): ScrollHint {
  if (scrollHeight - clientHeight <= 1) return "none";
  return scrollTop + clientHeight >= scrollHeight - 2 ? "end" : "more";
}
